import { BoatStore } from "stores/BoatStore";
import { ManageElement } from "./ManageElement";

export class Boat extends ManageElement {
  static _store: BoatStore;
}
